import { render, staticRenderFns } from "./SafePoint.vue?vue&type=template&id=d62c36f0&scoped=true&"
import script from "./SafePoint.vue?vue&type=script&lang=js&"
export * from "./SafePoint.vue?vue&type=script&lang=js&"
import style0 from "./SafePoint.vue?vue&type=style&index=0&id=d62c36f0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d62c36f0",
  null
  
)

export default component.exports